import formatMoney from '../formatMoney';

const updateFormControls = ({
  variant,
  qty,
  variantsData,
  optionNames,
  selectedOptions,
  atcButton,
  atcButtonPrice,
  atcButtonPipe,
  quantitySelector,
  sellingPlanId,
  getSellingPlanPrice
}) => {
  if (!atcButton || !atcButtonPrice || !quantitySelector) return;

  const allOptionsSelected = variantsData.length === 1 || optionNames.every(name => selectedOptions[name]);
  const quantityControls = quantitySelector.querySelectorAll('button, input');

  if (variant && variant.available && allOptionsSelected) {
    const price = getSellingPlanPrice(variant, sellingPlanId, 'price');
    quantitySelector.dataset.qtySelectorVariantPrice = price;
    quantityControls.forEach(control => control.removeAttribute('disabled'));
    atcButton.disabled = false;
    atcButtonPrice.textContent = formatMoney(price * qty);
    atcButtonPipe.classList.remove('hidden');
  } else {
    quantityControls.forEach(control => control.setAttribute('disabled', true));
    atcButton.disabled = true;
    atcButtonPrice.textContent = '';
    atcButtonPipe.classList.add('hidden');
  }
};

export default updateFormControls;
